// extracted by mini-css-extract-plugin
export default {"head":"Intro-head_TBj1x","icon":"Intro-icon_HQC1W","title":"Intro-title_tULfg","justifyContentCenter":"Intro-justifyContentCenter_vOzLB","centered":"Intro-centered_f5ia4"};